/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisableAdditionalServiceReqVo
 */
export interface DisableAdditionalServiceReqVo {
    /**
     * 要禁用的附加服务编号
     * @type {Array<number>}
     * @memberof DisableAdditionalServiceReqVo
     */
    ids: Array<number>;
}

/**
 * Check if a given object implements the DisableAdditionalServiceReqVo interface.
 */
export function instanceOfDisableAdditionalServiceReqVo(value: object): value is DisableAdditionalServiceReqVo {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function DisableAdditionalServiceReqVoFromJSON(json: any): DisableAdditionalServiceReqVo {
    return DisableAdditionalServiceReqVoFromJSONTyped(json, false);
}

export function DisableAdditionalServiceReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisableAdditionalServiceReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function DisableAdditionalServiceReqVoToJSON(json: any): DisableAdditionalServiceReqVo {
    return DisableAdditionalServiceReqVoToJSONTyped(json, false);
}

export function DisableAdditionalServiceReqVoToJSONTyped(value?: DisableAdditionalServiceReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

